module.exports = __webpack_public_path__ + "img/QR_pat.ed2abf9d.png";